// The host's role rides in the LiveKit token metadata, so every participant can
// tell who the host is (used to show the brand logo instead of an animal face).
//
// A client can also become host/co-host mid-class (the "Claim host" button, or
// being promoted by the host). Its token metadata still says "student", so we
// ALSO keep a local flag: whatever this browser knows about itself always wins
// for its own card.
let localIsHost = false;

export function setLocalHostRole(isHost) {
  localIsHost = !!isHost;
}

export function isHostParticipant(p) {
  if (!p) return false;
  if (p.isLocal && localIsHost) return true;
  try {
    return JSON.parse(p.metadata || "{}")?.role === "host";
  } catch {
    return false;
  }
}
